export const BUILDER_URL = 'https://builder.vidapp.com';
export const TERMS_URL = 'https://vidapp.com/terms-and-conditions';
export const PRIVACY_URL = 'https://vidapp.com/privacy-policy/';
export const APP_ROUTE_PREFIX = '/sign-up/';
export const BASE_KAJABI_ROUTE = `${APP_ROUTE_PREFIX}create-free-trial-app-kajabi`;
export const BASE_VHX_ROUTE = `${APP_ROUTE_PREFIX}create-free-trial-app-vimeoott`;
export const BESTFIT_NONE = 'None of the above';
export const BASE_GENERIC_ROUTE = `${APP_ROUTE_PREFIX}create-free-app`;
export const ONBOARDING_FORM_WIDTH = '570px';
export const MOBILE_WIDTH = '600px';
